import type { ServiceQuotationApproval } from "../@types/services/ServiceQuotationApproval";
import { api } from "./api";

type UpdateServiceQuotationApprovalData = {
  justification: string;
  decision: "approve" | "reject";
};

export const getServiceQuotationApproval = async (
  id: number,
): Promise<ServiceQuotationApproval> => {
  const response = await api.get<ServiceQuotationApproval>(
    `/service_quotation_approvals/${id}`,
    {
      baseURL: "/vbuyer/api/v2",
    },
  );

  return response.data;
};

export const updateServiceQuotationApproval = async (
  serviceQuotationApprovalId: number,
  data: UpdateServiceQuotationApprovalData,
): Promise<ServiceQuotationApproval> => {
  const response = await api.put<ServiceQuotationApproval>(
    `/service_quotation_approvals/${serviceQuotationApprovalId}`,
    {
      service_quotation_approval: {
        decision: data.decision,
        justification: data.justification,
      },
    },
    {
      baseURL: "/vbuyer/api/v2",
    },
  );

  return response.data;
};
